import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class Models extends Component {
  render() {
    return (
      <EntityList apiRoute='api/models' title='Remorque - Modèles' editTitle='Modèle' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default Models;



/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/models.js
 **/